export default {
  accent: '#8746f4',
  dark: '#0f0f0f',
  black: '#000000',
  white: '#ffffff',
  border: '#353535',
  primary: {
    main: '#8746f4',
    dark: '#373737',
  },
  secondary: {
    main: '#ffffff',
    dark: '#838383',
  },
  background: {
    default: '#252525',
    paper: '#292929',
    paperLight: '#323336',
  },
  text: {
    primary: '#fff4f4',
    secondary: 'rgba(255,255,255,0.7)',
  },
  error: {
    main: '#8746f4',
  },
  warning: {
    main: '#ffb405',
  },
  info: {
    main: '#0e7ded',
  },
  success: {
    main: '#80db25',
  },
};
